import React from 'react'
import {
  LoadingSpinner as PPLoadingSpinner,
  type LoadingSpinnerProps,
} from '@paypalcorp/pp-react'
import * as styles from './loadingSpinner.css'
import { useLocalizedContent } from '../../hooks/useLocalizedContent'

interface Props extends LoadingSpinnerProps {
  usePercentContainerStyle?: boolean
  useContainer?: boolean
}
export const LoadingSpinner = (props: Props) => {
  const { getContent } = useLocalizedContent()

  // Assign a new variable for spinnerProps and exclude usePercentContainerStyle
  // because it should NOT be passed to PPLoadingSpinner
  // since it's not a valid property of that component
  // this reduces noise in build and unit tests
  const {
    usePercentContainerStyle = false,
    useContainer = true,
    ...spinnerProps
  } = props

  const loadingComponent = (
    <PPLoadingSpinner
      data-testid="ppLoadingSpinner"
      size={props.size || 'xl'}
      className={styles.loadingSpinner}
      screenReaderText={getContent('app.screenReaderText.loading')}
      {...spinnerProps}
    />
  )

  if (useContainer) {
    return (
      <div
        data-testid="loadingSpinner"
        className={
          usePercentContainerStyle
            ? styles.loadingSpinnerPercentageContainer
            : styles.loadingSpinnerContainer
        }
      >
        {loadingComponent}
      </div>
    )
  }

  return loadingComponent
}
